import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckboxcheckicon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 11,
	viewBox: "0 0 12 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.5 6L4.5 9.5L10 1.5",
		stroke: "white",
		strokeWidth: 3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheckboxcheckicon;
